export default {"src":"/_next/static/media/Logo-Hoag.d7d344a3.svg","height":28,"width":68,"blurWidth":0,"blurHeight":0};